module.exports = __webpack_public_path__ + "static/media/cheese.c60e48fc.jpg";